var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    preserveAspectRatio: "xMidYMid meet",
    className: "",
    style: {
      verticalAlign: "middle",
      color: "rgb(87, 142, 224)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm2.968-4.115A6.502 6.502 0 0 0 6.605 14.35l-.131-.656a3.25 3.25 0 0 0-.741-1.503l-.556-.635c-.966-1.105-.786-2.66.136-3.568a5.29 5.29 0 0 1-2.345-4.103Zm1.675-1.452A3.786 3.786 0 0 0 5.92 6.578a2.46 2.46 0 0 1 2.192-2.093 2.674 2.674 0 0 0 2.305-1.926l.152-.531A6.479 6.479 0 0 0 8 1.5a6.47 6.47 0 0 0-3.357.933Zm7.264.372-.047.166a4.174 4.174 0 0 1-3.598 3.007.963.963 0 0 0-.814 1.272h2.27c2.193 0 3.469 2.479 2.194 4.264-.225.314-.475.61-.749.883l-1.998 1.999a6.502 6.502 0 0 0 2.742-11.591ZM7.053 8.75l-.077.011a1.096 1.096 0 0 0-.67 1.807l.556.635a4.75 4.75 0 0 1 1.083 2.196l.016.08 2.142-2.142c.215-.215.412-.448.588-.695.566-.792 0-1.892-.973-1.892H7.053Z",
    fill: "currentcolor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsServicesIcon);
export default __webpack_public_path__ + "static/media/terms-services-icon.67524f3eb8825e734714fbae6e3ff628.svg";
export { ForwardRef as ReactComponent };